import { CustomerName } from '../../customer/models/customer-name.model';

export class FleetModel {
    public id: number;
    public customerNumberId: number;
    public customerAccountNumberId: number;
    public fleetTypeId: number;
    public fleetStatusTypeId: number;
    public fleetNumber: number;
    public fleetCustomerName: CustomerName;
    public fleetVehicleCount: number;
    public expirationDate: Date;
    public lastRenewalDate: Date;
    public contacts: number[];
    public businessUnitTypeId: number;
}
